/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AvailablePrincipals model module.
 * @module model/AvailablePrincipals
 * @version 1.0.0
 */
class AvailablePrincipals {
    /**
     * Constructs a new <code>AvailablePrincipals</code>.
     * @alias module:model/AvailablePrincipals
     */
    constructor() { 
        
        AvailablePrincipals.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AvailablePrincipals</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AvailablePrincipals} obj Optional instance to populate.
     * @return {module:model/AvailablePrincipals} The populated <code>AvailablePrincipals</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AvailablePrincipals();

            if (data.hasOwnProperty('groups')) {
                obj['groups'] = ApiClient.convertToType(data['groups'], ['String']);
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AvailablePrincipals</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AvailablePrincipals</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['groups'])) {
            throw new Error("Expected the field `groups` to be an array in the JSON data but got " + data['groups']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['roles'])) {
            throw new Error("Expected the field `roles` to be an array in the JSON data but got " + data['roles']);
        }

        return true;
    }


}



/**
 * @member {Array.<String>} groups
 */
AvailablePrincipals.prototype['groups'] = undefined;

/**
 * @member {Array.<String>} roles
 */
AvailablePrincipals.prototype['roles'] = undefined;






export default AvailablePrincipals;

